/**
 * Converts hex color to HSL and claculates hue rotation
 * @param {string} sourceHex - Original color (in hexadecimal)
 * @param {string} targetHex - Target color (in hexadecimal)
 * @returns {number} Rotation angle in degrees
 */
export function getHueRotation(sourceHex, targetHex) {
    const hexToRgb = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16) / 255;
        const g = parseInt(hex.slice(3, 5), 16) / 255;
        const b = parseInt(hex.slice(5, 7), 16) / 255;
        return [r, g, b];
    };

    const rgbToHsl = (r, g, b) => {
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h;

        if (max === min) {
            h = 0;
        } else {
            const d = max - min;
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h *= 60;
        }
        
        return h;
    };

    const sourceRgb = hexToRgb(sourceHex);
    const targetRgb = hexToRgb(targetHex);

    const sourceHue = rgbToHsl(...sourceRgb);
    const targetHue = rgbToHsl(...targetRgb);

    // Calculate shortest rotation
    let hueDiff = targetHue - sourceHue;
    if (Math.abs(hueDiff) > 180) {
        hueDiff = hueDiff > 0 ? hueDiff - 360 : hueDiff + 360;
    }

    return hueDiff;
}